import React from 'react';
import PropTypes from 'prop-types';
import { get, flow, map, flatten, getOr, uniqBy } from 'lodash/fp';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import CategoriesGallery from './CategoriesGallery';
// import MenuGallery from '../../components/MenuGallery';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';

const styles = css`
  position: relative;
  z-index: 1;
  .Photos_wrapper {
    padding-top: 60px;

    h3 {
      font-size: 32px;
      margin-bottom: 30px;
    }
  }
`;

function PhotoGallery({ page, router }) {
  const route = RouteCollection.getRouteByPath(get('location.pathname', router));
  const gallerySlug = get('params.gallery', route);
  let activeGallery;
  let photos = [];

  if (gallerySlug) {
    activeGallery = getOr([], 'photo_gallery', page)
      .find(g => Slugify(getOr('', 'photo_catergory', g)) === gallerySlug);
    photos = getOr([], 'images', activeGallery);
  } else {
    photos = flow(
      map('images'),
      flatten,
      uniqBy('contentUrl'),
    )(getOr([], 'photo_gallery', page));
  }
  return (

    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get('page_image.contentUrl', page)}
      />
      {/* <MenuGallery /> */}
      <div className={styles}>
        <CategoriesGallery
          page={page}
        />
        <div className="container Photos_wrapper">
          <div className="row">
            <div className="col-12">
              {
                activeGallery &&
                <h3 className="text-center PhotoGallery_categoryTitle">
                  {get('photo_catergory', activeGallery)}
                  {' '}
                  <span className="PhotoGallery_categoryPostTitle">Portfolio</span>
                </h3>
              }
              {
                !activeGallery &&
                <h3 className="text-center PhotoGallery_categoryTitle">
                  All
                  <span className="PhotoGallery_categoryPostTitle"> Portfolios</span>
                </h3>
              }
              <LightBoxPhotoList
                gallery={get('photo_category', activeGallery)}
                photos={photos}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

PhotoGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'galleries',
    router: true,
  },
  {
    ifMissing404: true,
  },
)(PhotoGallery);



// WEBPACK FOOTER //
// ./src/pages/PhotoGallery/index.js